import { cn } from 'lib/util/cn'
import { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface SelectionToolbarProps {
  portalId: string
  children: ReactNode
  className?: string
}
export default function SelectionToolbar({ portalId, children, className }: SelectionToolbarProps) {
  const [toolbarContainer, setToolbarContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const container = document.getElementById(portalId)
    setToolbarContainer(container)
  }, [portalId])

  if (!toolbarContainer) return null

  const toolbar = (
    <div
      className={cn(
        'tw-fixed tw-bottom-3 tw-left-1/2 tw-z-30 tw--translate-x-1/2 tw-transform tw-rounded-lg tw-bg-neutral-800 tw-text-white tw-opacity-80',
        className,
      )}
    >
      {children}
    </div>
  )

  return createPortal(toolbar, toolbarContainer)
}
